// preparer#522: the Preparer App's link and create-client flows open these pages with the flow's
// W3C traceparent as a query parameter (a navigation cannot carry a header), and
// getUrlParameters stores every query parameter in sessionStorage. Passing it along on our API
// calls makes THAuth continue that trace, and THAuth puts it back on the redirect to the Preparer
// App, so the whole flow is one trace.
//
// Passed along unchanged: this page creates no span of its own, so the preparer's span is the
// real parent of every THAuth request in the flow.
//
// When nothing was carried in, there is no header at all. THAuth then starts the trace and makes
// the sampling decision, as the first service with a sampler should. A header made up here would
// either force every trace to be kept (-01) or every trace to be dropped (-00).
const TRACEPARENT = /^00-[0-9a-f]{32}-[0-9a-f]{16}-[0-9a-f]{2}$/

export default function getTraceparent() {
	const carried = (sessionStorage.getItem('traceparent') || '').trim()
	return TRACEPARENT.test(carried) ? carried : null
}

// Adds the traceparent to a fetch headers object only when there is one. A null value would be
// sent as the literal header "traceparent: null".
export function withTraceparent(headers) {
	const traceparent = getTraceparent()
	return traceparent ? {...headers, traceparent} : headers
}
